
import { FileContainerModel } from '../../../../../../models/aggregates/fm/file';
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config } from '../../shared';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class FileService extends BaseApiTemplateService<FileContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FM_MODULE + 'files';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FM_MODULE + 'files';
    this.httpClient = http;
  }

  uploadFile(formData: FormData, hdrGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<any>>{
    let url = this.apiUrl + '/file/upload/' + hdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/upload' + hdrGuid;
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(
      url,
      formData,
      this.getHttpHeader(visa)
    );
  }

  replaceFile(formData: FormData, hdrGuid: string, visa: ApiVisa) {
    let url = this.apiUrl + '/replace-file/' + hdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/replace-file/' + hdrGuid;
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(url, formData, this.getHttpHeader(visa));
  }

  getFilePublic(hdrGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/file/public/' + hdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/public/' + hdrGuid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  getFile(hdrGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/file/' + hdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + hdrGuid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  updateAclPolicyAndConfig(hdrGuid: string, body: any, visa: ApiVisa) {
    let url = this.apiUrl + '/acl-cfg-policy/backoffice-ep/' + hdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/acl-cfg-policy/backoffice-ep/' + hdrGuid;
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      url,
      body,
      this.getHttpHeader(visa)
    );
  }

  updateAclPolicy(hdrGuid: string, body: any, visa: ApiVisa) {
    let url = this.apiUrl + '/acl-policy/backoffice-ep/' + hdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/acl-policy/backoffice-ep/' + hdrGuid;
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      url,
      body,
      this.getHttpHeader(visa)
    );
  }

  aclConfigGuestAdd(hdrGuid: string, body: any, visa: ApiVisa) {
    let url = this.apiUrl + '/acl-cfg-guest-add/backoffice-ep/' + hdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/acl-cfg-guest-add/backoffice-ep/' + hdrGuid;
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      url,
      body,
      this.getHttpHeader(visa)
    );
  }

  aclConfigGuestDelete(hdrGuid: string, body: any, visa: ApiVisa) {
    let url = this.apiUrl + '/acl-cfg-guest-delete/backoffice-ep/' + hdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/acl-cfg-guest-delete/backoffice-ep/' + hdrGuid;
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      url,
      body,
      this.getHttpHeader(visa)
    );
  }

}
